// 1. FIXED PollComponent - Replace your current one
import React, { useState, useEffect } from 'react';

export const PollComponent = ({ options, totalVotes, pollEndsIn, userVoted, userVotedOptionId, onVote }) => {
  const [selectedOption, setSelectedOption] = useState(userVotedOptionId || null);
  const [showResults, setShowResults] = useState(userVoted);
  const [animatedVotes, setAnimatedVotes] = useState({});

  // Update when props change (when user returns to page after voting)
  useEffect(() => {
    setShowResults(userVoted);
    setSelectedOption(userVotedOptionId || null);
  }, [userVoted, userVotedOptionId]);

  const handleVote = (optionId) => {
    if (!userVoted) {
      setSelectedOption(optionId);
      setShowResults(true);
      onVote(optionId);
      
      // Animate vote count increase
      setAnimatedVotes(prev => ({...prev, [optionId]: true}));
      setTimeout(() => {
        setAnimatedVotes(prev => ({...prev, [optionId]: false}));
      }, 600);
    }
  };

  return (
    <div style={{
      marginTop: '16px',
      padding: '20px',
      background: 'linear-gradient(135deg, #1a2e2e 0%, #0f2027 100%)',
      borderRadius: '16px',
      border: '1px solid #2d4a4a',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <div style={{
          width: '32px',
          height: '32px',
          background: 'linear-gradient(135deg, #00d4aa, #10b981)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '12px'
        }}>
          <span style={{ fontSize: '16px' }}>🗳️</span>
        </div>
        <div>
          <h4 style={{ margin: 0, fontWeight: '600', color: '#065f46' }}>Community Poll</h4>
          <p style={{ margin: 0, fontSize: '14px', color: '#047857' }}>
            {totalVotes} votes • {pollEndsIn ? `Ends in ${pollEndsIn}` : 'Poll closed'}
            {userVoted && <span style={{ color: '#00d4aa', marginLeft: '8px' }}>• You voted</span>}
          </p>
        </div>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {options.map((option) => {
          const isUserChoice = selectedOption === option.id;
          
          return (
            <div
              key={option.id}
              onClick={() => handleVote(option.id)}
              style={{
                position: 'relative',
                padding: '16px',
                borderRadius: '12px',
                border: showResults && isUserChoice ? '2px solid #00d4aa' : 
                       showResults ? '2px solid #2d4a4a' : '2px solid transparent',
                backgroundColor: 'white',
                cursor: userVoted ? 'default' : 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                transform: isUserChoice ? 'scale(1.02)' : 'scale(1)',
                boxShadow: isUserChoice ? '0 8px 25px -5px rgba(16, 185, 129, 0.3)' : 
                          '0 2px 4px -1px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                if (!userVoted) {
                  e.currentTarget.style.transform = 'scale(1.01)';
                  e.currentTarget.style.boxShadow = '0 4px 12px -2px rgba(16, 185, 129, 0.2)';
                }
              }}
              onMouseLeave={(e) => {
                if (!userVoted && !isUserChoice) {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 4px -1px rgba(0, 0, 0, 0.1)';
                }
              }}
            >
              {showResults && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    background: isUserChoice 
  ? 'linear-gradient(90deg, rgba(16, 185, 129, 0.8) 0%, rgba(16, 185, 129, 0.6) 100%)'
  : 'linear-gradient(90deg, rgba(16, 185, 129, 0.6) 0%, rgba(16, 185, 129, 0.4) 100%)',
                    borderRadius: '10px',
                    transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
                    width: `${option.percentage}%`
                  }}
                />
              )}
              <div style={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                zIndex: 1
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '20px' }}>{option.emoji}</span>
                  <span style={{ 
                    fontWeight: isUserChoice ? '600' : '500', 
                    color: isUserChoice ? '#00d4aa' : '#b3b3b3' 
                  }}>
                    {option.text}
                    {isUserChoice && showResults && (
                      <span style={{ marginLeft: '8px', fontSize: '14px' }}>✓</span>
                    )}
                  </span>
                </div>
                {showResults && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{
                      fontWeight: '600',
                      color: '#00d4aa',
                      transform: animatedVotes[option.id] ? 'scale(1.2)' : 'scale(1)',
                      transition: 'transform 0.3s ease'
                    }}>
                      {option.votes} votes
                    </span>
                    <span style={{
                      backgroundColor: isUserChoice ? '#00d4aa' : '#6b7280',
                      color: 'white',
                      padding: '4px 8px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      {option.percentage}%
                    </span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
